module.exports = __webpack_public_path__ + "img/icon_map_37_on_001.81b101e7.png";